import { Theme } from '@mui/material'

const useStyles = {
  footer: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.primary50,
    height: '148px',
    position: 'fixed',
    bottom: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '16px 0 40px 0',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    zIndex: 1,
  }),
  lightBackgroundFooter: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
  }),
}

export default useStyles
